import { render, staticRenderFns } from "./TheBoar.vue?vue&type=template&id=07bb05d0&scoped=true&"
import script from "./TheBoar.vue?vue&type=script&lang=js&"
export * from "./TheBoar.vue?vue&type=script&lang=js&"
import style0 from "./TheBoar.vue?vue&type=style&index=0&id=07bb05d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bb05d0",
  null
  
)

export default component.exports